export default theme => ({

  root: {
    marginTop: theme.spacing.unit * 3
  },

  text: {
    color: '#ffffff'
  },

  actionsContainer: {
    marginTop: theme.spacing.unit,
  },

  actionsButton: {
    marginRight: theme.spacing.unit
  },

  code: {
    fontFamily: 'monospace',
    opacity: '0.8',
    backgroundColor: theme.palette.background.default,
    borderRadius: '3px',
    padding: '1px 5px'
  },

  preBlock: {
    padding: '0 15px'
  }

});






// WEBPACK FOOTER //
// ./src/styles/components/WidgetCode.js